export default "__VITE_ASSET__Dzhvpufn__"